import { convertToSpamVolume } from 'util/computeDataCompWithSpam';
import getKeyFromDataBrand from 'util/getKeyFromDataBrand';
import { EXTRA_COST_BSI } from 'constants/DefineConst';


export const computeTimeConstraint = (inputDataComp, freqInput) => {
  let constraintTime = 0;
  switch(freqInput) {
    case 'Daily':
      constraintTime = inputDataComp * 1 / 30;
      break;
    case 'Weekly':
      constraintTime = inputDataComp * 1 / 4;
      break;
    case 'Biweekly':
      constraintTime = inputDataComp * 1 / 2;
      break;
    case 'Quarterly':
      constraintTime = inputDataComp * 3;
      break;
    case 'Yearly':
      constraintTime = inputDataComp * 12;
      break;
    default:
      constraintTime = inputDataComp;
  }
  return constraintTime;
};

const convertUnitCost = (data, unitTimeCost) => {
  for (let i = 0; i < 10; i+=1) {
    data[`brand${i+1}`] = Math.round(unitTimeCost[i]);
  }
  return data;
}


export default (newData, inputFields, rateCards, dataComp, freq, peopleLevelList, oldDataComp, spamOfCategory) => {
  let totalHour = 0;
  let totalPrice = 0;
  let unitTimeCost = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  let unitTimeTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  const categorySegment = inputFields.category ? inputFields.category.split('_') : [];
  const level = categorySegment.length > 0 ? categorySegment[1] : null;
  const bsi = newData.find(item => item.sow === 'BSI');
  const sample = newData.find(item => item.sow === 'Sample');
  delete oldDataComp[0].name;
  const convertedNewData = newData.map(item => {
    const rateCard = rateCards.find(e => e.sow === item.sow);
    if (['4', '5', '6', '7', '8', '9', '10'].includes(item.key)) {
      item.freq = inputFields.data_freq;
    }
    const valueFreqInput = freq.find(e => e.name === inputFields.data_freq);
    const valueDataFreq = freq.find(e => e.name === item.freq);
    const constraintFreq = valueFreqInput && valueDataFreq && valueDataFreq.rank < valueFreqInput.rank ? 1.01 : 1;
    const sum = Object.keys(dataComp[0]).reduce((result, key, index) => {
      const keyBrand = getKeyFromDataBrand(key);
      const oldData = item.key === '0' ? convertToSpamVolume(oldDataComp[0][key], spamOfCategory) : oldDataComp[0][key];
      if (['0', '1', '2'].includes(item.key) && bsi[`brand${index + 1}`]) {
        const unitTime = (sample[keyBrand && keyBrand.name] && item.key === '1' ? dataComp[0][key] : computeTimeConstraint(item.key === '1' ? dataComp[0][key] : oldData, inputFields.data_freq)) * item[`brand${index + 1}`] * 1.3;
        unitTimeCost[index] = unitTimeCost[index] * 1 + (rateCard ? ((level && rateCard[level] ? rateCard[level] : 0) * unitTime * constraintFreq) / 3600 * rateCard.rate_card : 0);
        unitTimeTotal[index] = unitTimeTotal[index] * 1 + (rateCard ? ((level && rateCard[level] ? rateCard[level] : 0) * unitTime * constraintFreq) / 3600 : 0);
        return result + unitTime;
      }
      const unitTime = (sample[keyBrand && keyBrand.name] && ['1', '3'].includes(item.key) ? dataComp[0][key] : computeTimeConstraint(['1', '3'].includes(item.key) ? dataComp[0][key] : oldData, inputFields.data_freq)) * item[`brand${index + 1}`];
      unitTimeCost[index] = unitTimeCost[index] * 1 + (rateCard ? ((level && rateCard[level] ? rateCard[level] : 0) * unitTime * constraintFreq) / 3600 * rateCard.rate_card : 0);
      unitTimeTotal[index] = unitTimeTotal[index] * 1 + (rateCard ? ((level && rateCard[level] ? rateCard[level] : 0) * unitTime * constraintFreq) / 3600 : 0);
      return result + unitTime;
    }, 0);

    item.time = rateCard ? ((level && rateCard[level] ? rateCard[level] : 0) * sum * constraintFreq) / 3600 : 0;

    if (item.key === '6') {
      const sumTime = newData.reduce((res, element) => {
        if (['0', '1', '2', '3', '4', '5'].includes(element.key)) {
          return res + element.time * 1;
        }
        return res;
      }, 0);
      Object.keys(oldDataComp[0]).forEach((key, index) => {
        unitTimeCost[index] = unitTimeCost[index] * 1 +  unitTimeTotal[index] * 0.1 * rateCard.rate_card;
      });
      item.time = sumTime * 0.1;
    }

    if (item.key === '7') {
      const sum = Object.keys(oldDataComp[0]).reduce((result, key, index) => {
        const mainInChargeLevel = peopleLevelList ? peopleLevelList.find(level => level.task === 'Charting & Analysis (Main incharge)' && level.report_level === item[`brand${index + 1}`]) : null;
        const supporterLevel = peopleLevelList ? peopleLevelList.find(level => level.task === 'Charting & Analysis (Supporter)' && level.report_level === item[`brand${index + 1}`]) : null;
        // const workingHours = peopleLevelList ? peopleLevelList.reduce((res, peopleLevel) => {
        //   if (peopleLevel.task.includes('Charting & Analysis') && peopleLevel.report_level === item[`brand${index + 1}`]) {
        //     return res + peopleLevel.working_hour * 1;
        //   }
        //   return res;
        // }, 0) : 0;
        const workingHours = mainInChargeLevel && supporterLevel ? mainInChargeLevel.working_hour * 1 + supporterLevel.working_hour * 1 : 0;
        const mainInChargeHour = mainInChargeLevel ? mainInChargeLevel.working_hour : 0;
        const supportHour = supporterLevel ? supporterLevel.working_hour : 0;
        result.time = item[`brand${index + 1}`] && workingHours ? result.time + workingHours : result.time;
        const unitPrice = item[`brand${index + 1}`] && workingHours ? mainInChargeHour * mainInChargeLevel.price + supportHour * supporterLevel.price : 0;
        unitTimeCost[index] = unitTimeCost[index] * 1 + unitPrice;
        result.price = result.price + unitPrice;
        return result;
      }, {time: 0, price: 0});
      item.time = sum.time;
      item.unit_price = sum.price;
    }

    if (item.key === '8') {
      const findElement = newData.find(item => item.key === '7');
      const sum = Object.keys(oldDataComp[0]).reduce((result, key, index) => {
        const peopleLevel = peopleLevelList ? peopleLevelList.find(level => level.task === 'Project Management' && level.report_level === findElement[`brand${index + 1}`]) : null;
        result.time = peopleLevel && oldDataComp[0][key] ? result.time + peopleLevel.working_hour * 1 : result.time;
        const unitPrice = peopleLevel && oldDataComp[0][key] ? peopleLevel.working_hour * peopleLevel.price : 0;
        unitTimeCost[index] = unitTimeCost[index] * 1 + unitPrice;
        result.price = result.price + unitPrice;
        return result;
      }, { time: 0, price: 0});
      item.time = sum.time;
      item.unit_price = sum.price;
    }

    if (item.key === '9') {
      const findElement = newData.find(item => item.key === '7');
      const sum = Object.keys(oldDataComp[0]).reduce((result, key, index) => {
        const peopleLevel = peopleLevelList ? peopleLevelList.find(level => level.task === 'Client Service' && level.report_level === findElement[`brand${index + 1}`]) : null;
        const bsiNum = peopleLevel && peopleLevel.working_hour ? (bsi[`brand${index + 1}`] ? peopleLevel.working_hour * 1 * 1.3 : peopleLevel.working_hour * 1) : 0;
        result.time = peopleLevel && oldDataComp[0][key] ? result.time + bsiNum : result.time;
        const unitPrice = peopleLevel && oldDataComp[0][key] ? peopleLevel.working_hour * peopleLevel.price : 0;
        unitTimeCost[index] += unitPrice;
        result.price = result.price + unitPrice;
        return result;
      }, { time: 0, price: 0});
      item.time = sum.time;
      item.unit_price = sum.price;
    }

    if (item.key === '10') {
      const findElement = newData.find(item => item.key === '7');
      const sum = Object.keys(oldDataComp[0]).reduce((result, key, index) => {
        const peopleLevel = peopleLevelList ? peopleLevelList.find(level => level.task === 'General Management' && level.report_level === findElement[`brand${index + 1}`]) : null;
        result.time = peopleLevel && oldDataComp[0][key] ? result.time + peopleLevel.working_hour * 1 : result.time;
        const unitPrice = peopleLevel && oldDataComp[0][key] ? peopleLevel.working_hour * peopleLevel.price : 0;
        unitTimeCost[index] = unitTimeCost[index] * 1 + unitPrice;
        result.price = result.price + unitPrice;
        return result;
      }, { time: 0, price: 0});
      item.time = sum.time;
      item.unit_price = sum.price;
    }

    if (item.key === '5') {
      const sum = Object.keys(oldDataComp[0]).reduce((result, key, index) => {
        const extra = item[`brand${index + 1}`] ? EXTRA_COST_BSI : 0;
        unitTimeCost[index] =  unitTimeCost[index] * 1 + extra;
        return result + extra;
      }, 0);
      item.unit_price = sum;
    } else if (!['7', '8', '9', '10'].includes(item.key)) {
      item.unit_price = rateCard ? item.time * rateCard.rate_card : 0;
    }
    totalHour += item.time * 1;
    totalPrice += item.unit_price * 1;
    return item;
  });

  convertedNewData[11] = convertUnitCost(convertedNewData[11], unitTimeCost);

  return {
    convertedNewData,
    totalHour,
    totalPrice,
  };
};
